module.exports = __webpack_public_path__ + "assets/retina_ParallelogramVOn4LinesDetailed.358aedde915fbc220bd816978bec14c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_ParallelogramVOn4LinesDetailed.png
// module id = 702
// module chunks = 0